<template>
  <div
    :style="
      clientStore.getCustomBackgroundImagePath !== null
        ? 'background-image: url(' +
          clientStore.getCustomBackgroundImagePath +
          '); '
        : ''
    "
    :class="{
      'custom-background-image':
        clientStore.getCustomBackgroundImagePath !== null,
    }"
  >
    <BackgroundBubbles
      v-if="clientStore.getCustomBackgroundImagePath === null"
    />
    <div
      class="m-auto lg:h-screen max-w-7xl flex justify-center align-middle flex-col"
    >
      <h2 class="textHeadline2 text-white mb-8 mx-auto text-center">
        {{ $t("ssosbk.register.success.title") }}
      </h2>
      <div
        class="block md:flex flex-col lg:flex-row basis-1/3 justify-center text-center px-4 gap-6 text-xl font-bold"
      >
        {{ $t("ssosbk.register.success.text") }}
      </div>
      <div class="block md:flex flex-col justify-center gap-6">
        <div class="text-xl font-bold text-center mx-auto pt-4 w-96 px-4">
          {{ $t("ssosbk.activation.resend.text") }}
          <div v-if="isResendActivation" class="mt-4">
            {{ $t("ssosbk.activation.resend.success.text") }}
          </div>
        </div>
        <div class="text-xl mx-auto pt-8 w-96 px-4">
          <input
            v-model="resendLinkMail"
            placeholder="E-Mail"
            type="text"
            class="input-primary w-full"
          />
          <div
            class="cursor-pointer mt-4 w-full col-span-2 button-bkk-100 !text-background"
            @click="resendActivationLink"
          >
            {{ $t("ssosbk.activation.resend.button") }}
          </div>
          <div
            v-if="resendMailError"
            class="cursor-pointer mt-2 w-full col-span-2 text-red-800"
          >
            {{ $t("ssosbk.resendActivationMail.modal.error") }}
          </div>
        </div>
      </div>
    </div>
    <FooterLinks bg-fixed />
  </div>
</template>

<script>
import BackgroundBubbles from "../../../components/v2/layout/BackgroundBubbles";
import { useClientStore } from "../../../store/v2/client";
import { resendActivation } from "../../../api/sbk";
import FooterLinks from "../../../components/v2/sbk/FooterLinks.vue";
import { SBK_BLUE } from "../../../enum/v2/sbk";

export default {
  name: "SbkRegisterSuccessPage",
  components: {
    FooterLinks,
    BackgroundBubbles,
  },
  setup() {
    const clientStore = useClientStore();
    return {
      clientStore,
    };
  },
  data() {
    return {
      client: null,
      isLoading: Boolean,
      isResendActivation: false,
      resendLinkMail: null,
      resendMailError: null,
    };
  },
  async mounted() {
    this.clientStore.setAtmCampaign(this.$route.params.atmCampaign);
    this.clientStore.setPasswordResetRedirectTarget("register");
    this.clientStore.setClientColorsManually(
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE
    );

    this.client = await this.clientStore.getClient(
      null,
      this.$route.params.atmCampaign
    );
  },
  methods: {
    async resendActivationLink() {
      if (!this.resendLinkMail) {
        return;
      }

      this.isResendActivation = true;
      await resendActivation(this.resendLinkMail).catch((error) => {
        this.resendMailError = error;
      });
    },
  },
};
</script>
